import React from 'react';

import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

import { useUiContext } from '../../../../../../context/UiContext';
import InvoiceService from '../../../../../../services/InvoiceService';

export default function DeleteButton({ invoiceId, loanId }) {
  const { showDialogModal, showToast } = useUiContext();

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  return (
    <button
      type="button"
      className="text-rose-500 hover:text-rose-600 rounded-full"
      onClick={() => {
        showDialogModal({
          title: 'Delete Invoice',
          message: 'Are you sure you want to delete this invoice?',
          onConfirm: async () => {
            try {
              await InvoiceService.deleteInvoice(invoiceId);

              showToast({
                text: 'Invoice deleted successfully',
                type: 'success',
              });
              queryClient.invalidateQueries({ queryKey: ['schedule', loanId] });
              navigate(`/loans/${loanId}?tab=Schedule`);
            } catch (error) {
              console.log(error);
              showToast({
                text: error?.response?.data?.message || 'Something went wrong',
                type: 'error',
              });
            }
          },
          type: 'danger',
        });
      }}
    >
      <span className="sr-only">Delete</span>
      <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
        <path d="M13 15h2v6h-2zM17 15h2v6h-2z" />
        <path d="M20 9c0-.6-.4-1-1-1h-6c-.6 0-1 .4-1 1v2H8v2h1v10c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V13h1v-2h-4V9zm-6 1h4v1h-4v-1zm7 3v9H11v-9h10z" />
      </svg>
    </button>
  );
}
